import VuexPersistence from 'vuex-persist'

export default ({ store }) => {
  window.onNuxtReady(() => {
    new VuexPersistence({
      reducer: state => ({ tenantInformation: state.tenantInformation, setupInformation: state.setupInformation })
    }).plugin(store)
  })
}
